import React from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

export default function AnnouncementBar() {
  const [visible, setVisible] = React.useState(true);
  if (!visible) return null;
  return (
    <div
      className="lm-announcement relative w-full text-white text-sm font-medium overflow-hidden"
      data-testid="landing-announcement"
    >
      <div className="relative max-w-7xl mx-auto px-5 md:px-10 py-2.5 flex items-center justify-center gap-2 text-center">
        <span className="text-white/95">
          One plan · <span className="font-semibold">15 scans/month</span>, 15 keywords each ·{" "}
          <Link
            to="/pricing"
            data-testid="announcement-price-link"
            className="text-white font-semibold underline underline-offset-4 decoration-white/60 hover:decoration-white transition-colors"
          >
            ₹1,999/mo
          </Link>
          {" "}· get started
        </span>
        <Link
          to="/pricing"
          data-testid="announcement-cta-link"
          className="hidden md:inline-flex items-center gap-1 text-white font-semibold underline underline-offset-4 decoration-white/60 hover:decoration-white transition-colors"
        >
          See pricing →
        </Link>
      </div>
      <button
        onClick={() => setVisible(false)}
        aria-label="Dismiss announcement"
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/60 hover:text-white transition-colors z-10"
        data-testid="dismiss-announcement"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
